

/**
 * --------
 * NOTE
 * --------
 * US_PRIVACY is cookies string use to comunicate user privacy and data consent preferences.
 * However the mmw currently doesn't set this cookie, 
 * and since they are specific to the domain that sets them 
 * (meaning a cookie set by other websites cannot be read by ignite due to browser secure messaures),
 * we will get null, until this is supported (gdpr falls into this too).
 *
 */

export function getUSPrivacy() {
  const name = 'usprivacy';
  const cookieArr = document.cookie.split(";");

  for(let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");

      if(name == cookiePair[0].trim()) {
          const usPrivacy = decodeURIComponent(cookiePair[1]);

          // Validate U.S. Privacy String
          if (/^[1-2][YN-][YN-][YN-]$/.test(usPrivacy)) {
              return {
                  version: usPrivacy.charAt(0),
                  explicitNotice: usPrivacy.charAt(1),
                  optOutSale: usPrivacy.charAt(2),
                  lspa: usPrivacy.charAt(3)
              };
          } else {
              console.error('Invalid U.S. Privacy String');
              return null;
          }
      }
  }

  return null;
}